import {firebaseServices} from '../Firebase/FirebaseServices';


let DBLastVisitFrameUpdate = (episode, Frame, dbTimeFolder) => {

    if(episode === 'episode1'){
        firebaseServices.database().ref(`/userDetails/${dbTimeFolder}/episode1`).child('episode1_lastVisitFrame').set(Frame)
    } else if(episode === 'episode2'){
        firebaseServices.database().ref(`/userDetails/${dbTimeFolder}/episode2`).child('episode2_lastVisitFrame').set(Frame)
    } else if(episode === 'episode3'){
        firebaseServices.database().ref(`/userDetails/${dbTimeFolder}/episode3`).child('episode3_lastVisitFrame').set(Frame)
    }
};

export default DBLastVisitFrameUpdate;